import SvgIcon from "src/components/shared/SvgIcon";

const IconDownload = (props: any) => {
  const size = props.size || 16;
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
        height={size}
        width={size}
        {...props}
      >
        {/*<!--!Font Awesome Pro v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2026 Fonticons, Inc.-->*/}
        <path d="M336 80C336 71.2 328.8 64 320 64C311.2 64 304 71.2 304 80L304 361.4L219.3 276.7C213.1 270.5 202.9 270.5 196.7 276.7C190.5 282.9 190.5 293.1 196.7 299.3L308.7 411.3C314.9 417.5 325.1 417.5 331.3 411.3L443.3 299.3C449.5 293.1 449.5 282.9 443.3 276.7C437.1 270.5 426.9 270.5 420.7 276.7L336 361.4L336 80zM181.5 352L160 352C124.7 352 96 380.7 96 416L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 416C544 380.7 515.3 352 480 352L458.5 352L426.5 384L480 384C497.7 384 512 398.3 512 416L512 480C512 497.7 497.7 512 480 512L160 512C142.3 512 128 497.7 128 480L128 416C128 398.3 142.3 384 160 384L213.5 384L181.5 352zM464 448C464 434.7 453.3 424 440 424C426.7 424 416 434.7 416 448C416 461.3 426.7 472 440 472C453.3 472 464 461.3 464 448z" />
      </svg>
    </SvgIcon>
  );
};
export default IconDownload;
